import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function updateFeideTwoSchool(school) {
	return fetch(
		`${ENDPOINT_URL}/updatefeidetwoschool`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(school),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
